import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import SelectDropdown from "../components-react/SelectDropdown";
import { fetchIndividualTypeData } from "../../redux/reducers/dropdownApiSlice";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import {
  add_approval_manager,
  update_approval_manager,
} from "../../data/ApiEndpoints";

const TMEApprovalManagerForm = ({
  userInfoData,
  closeModal,
  callFunction,
  rowData,
  isEdit,
}) => {
  const dispatch = useDispatch();
  const { individualData } = useSelector((state) => state.dropdown);
  const { loading } = useSelector((state) => state.common);

  const iniFormValues = [
    {
      selectedUser:
        isEdit && rowData?.user_id && rowData?.user_name
          ? {
              label: rowData.user_name,
              value: rowData.user_id,
            }
          : "",
    },
  ];
  const [formValues, setFormValues] = useState(iniFormValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeDropdown = (name, value) => {
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onSumitForm = (e) => {
    e.preventDefault();

    setFormErrors(validateFormValues(formValues));
    setIsSubmit(true);
  };

  const validateFormValues = (formValues) => {
    let errors = {};

    if (!formValues.selectedUser) {
      errors.selectedUser = "required!";
    }

    return errors;
  };

  function getAllAdmins() {
    dispatch(
      fetchIndividualTypeData({
        token: userInfoData?.token,
        qps: `account_type=admin`,
        pageNo: 1,
        limit: 100,
      })
    );
  }

  const handleAdd = async (requestBody) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit ? update_approval_manager : add_approval_manager;
    const payload = requestBody;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        setFormValues(iniFormValues);
        setIsSubmit(false);
        closeModal();
        callFunction();
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    getAllAdmins();
  }, []);

  useEffect(() => {
    setFormValues((prevs) => ({
      ...prevs,
      selectedUser:
        isEdit && rowData?.user_id && rowData?.user_name
          ? {
              label: rowData.user_name,
              value: rowData.user_id,
            }
          : "",
    }));
  }, [rowData]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        user_id: formValues.selectedUser?.value,
      };

      if (isEdit) {
        userData.uid = rowData.uid;
      }

      handleAdd(userData);
    }
  }, [isSubmit, formErrors]);

  return (
    <div className="form-container">
      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label htmlFor="selectedUser" className="formInputLabel">
              Choose Approval Manager <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selectedUser ? "formError" : ""
              }`}
            >
              <SelectDropdown
                options={
                  individualData && individualData?.length > 0
                    ? individualData
                    : []
                }
                selectedOption={formValues.selectedUser}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown("selectedUser", selectedValue)
                }
                name="Approval Manager"
              />
            </div>
          </div>
        </div>

        <div className="formButtons" style={{ justifyContent: "flex-end" }}>
          <Button className="saveBtn" variant="danger" onClick={onSumitForm}>
            {loading ? <ReactVortoxSpinner /> : "Submit"}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default TMEApprovalManagerForm;
